// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3877":"fe336940f98fdfab","4213":"f4fc9844a5478d4d","6676":"7d7b169f47a5058e","7584":"a5f0c83ca3a862b0"}[chunkId] + ".css";
};